<template>
    <div class="title" :style="noBorder?'border:0':''">{{title}}</div>
</template>

<script>
    export default {
        name: "Title",
        props:{
            title:String,
            noBorder:Boolean
        },
    }
</script>

<style scoped>
    .title{
        font-size: 16px;
        font-weight: 700;
        color: #000;
        padding: 10px 20px;
        background-color: #fff;
        border-bottom: 1px solid #ddd;
    }
</style>